import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import TradeIn from "@/pages/TradeIn";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ConsignorPortal from "@/pages/ConsignorPortal";
import InvestorPortal from "@/pages/InvestorPortal";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function ProtectedAdmin({ children }) {
  const { admin } = useAuth();
  if (admin === null) {
    return <div className="min-h-screen grid place-items-center text-zinc-400">Cargando…</div>;
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  if (admin.role === "consignador") return <Navigate to="/portal" replace />;
  if (admin.role === "inversionista") return <Navigate to="/inversionista" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<TradeIn />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
            <Route path="/portal" element={<ConsignorPortal />} />
            <Route path="/inversionista" element={<InvestorPortal />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
